import { GivingOldTheme } from './theme/giving-old';
export function isGivingOldTheme(theme) {
  return theme.colors['product-color'] === GivingOldTheme.colors['product-color'];
}